import type { ReactNode } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTransfertsEditionContext } from "../store/transfertsEditionContext";
import Competence from "constants/Competence";
import PerimetreEditTransfertsTableContent from "./PerimetreEditTransfertsTableContent";
import { grey } from "@mui/material/colors";

function PerimetreEditTransfertsList(): ReactNode {
  const {
    state: { perimetre: { competence } = {}, filteredTransferts, isLoading },
  } = useTransfertsEditionContext();
  const showBassinVersant = competence === Competence.GCE;

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table sx={{ "tr:last-of-type td": { borderBottom: "none" } }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: grey[100] }}>
            <TableCell padding="checkbox" sx={{ lineHeight: "1em", py: 1.5 }}></TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Commune</Typography>
            </TableCell>
            {showBassinVersant && (
              <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
                <Typography sx={{ fontWeight: 600 }}>Bassin versant</Typography>
              </TableCell>
            )}
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>EPCI</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Sous-Compétence</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Portée</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Tooltip
                arrow
                title="La date d'effet de la dernière modification du transfert (par exemple un changement de l'entité transférante, ou un changement d'affectation à un périmètre SDEA). Cette date n'est pas affichée dans l'application, mais stockée à toute fin utile."
                disableInteractive={false}>
                <Typography sx={{ fontWeight: 600 }}>
                  Date d'effet
                  <InfoIcon sx={{ fontSize: "0.8rem", ml: 0.25, verticalAlign: "super" }} />
                </Typography>
              </Tooltip>
              <Typography variant="caption">dd/MM/yyyy</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Délibération</Typography>
              <Typography variant="caption">dd/MM/yyyy</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Tooltip
                arrow
                title="La date de début enregistrée à la création du transfert pour la sous-compétence / portée."
                disableInteractive={false}>
                <Typography sx={{ fontWeight: 600 }}>
                  Début de transfert
                  <InfoIcon sx={{ fontSize: "0.8rem", ml: 0.25, verticalAlign: "super" }} />
                </Typography>
              </Tooltip>
              <Typography variant="caption">dd/MM/yyyy</Typography>
            </TableCell>
            <TableCell sx={{ lineHeight: "1em", py: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Assemblée Générale</Typography>
              <Typography variant="caption">dd/MM/yyyy</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <PerimetreEditTransfertsTableContent
            isLoading={isLoading}
            showBassinVersant={showBassinVersant}
            transferts={filteredTransferts}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PerimetreEditTransfertsList;
